

















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { RegService } from "@common/service/base-service/reg";
import { PartnerService } from "@/zh-website/src/views/partner/service";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { HomeService } from "@/zh-website/src/views/Homes/service";
@Component({
  components: {
    ReadTo
  }
})
export default class Apply extends Vue {
  pname = "";
  pdata = "";
  puser = "";
  phone = { val: "", err: false };
  email = { val: "", err: false };
  casename = "";
  casename2 = "";
  casename3 = "";
  casecon1 = "";
  casecon2 = "";
  casecon3 = "";
  casecon4 = "";
  casecon5 = "";
  casename4 = "";
  casecon6 = "";
  checkList = "";
  radio = "3";
  activeIndex = 0;
  isShow = 2;
  title = "面授课程合作";
  desc =
    "欢迎进入浙江华为讲师资源库，与我们一同基于客户业务场景联合开发专业的培训课程";
    isCheck = false;
    rulecode="";
  codeImg = "";
  rulecodes="";
  changeMode() {
    this.$emit("changeTab", this.radio);
  }
  mounted() {
    this.getCode();
  }
   //改变验证码
   changeCode() {
    this.getCode();
  }
  getCode() {
    HomeService.getCode().then(res => {
      this.codeImg = `data:image/png;base64,${res.data.code}`;
      this.rulecodes = res.data.codeNum;
    });
  }
  phoneTest() {
    const reg = RegService.PHONE;
    const that = this;
    if (
      that.phone.val == "" ||
      that.phone.val.length <= 10 ||
      !reg.test(that.phone.val)
    ) {
      that.phone.err = true;
      that.$message.error("手机号码错误");
      that.phone.val = "";
      return false;
    } else {
      that.phone.err = false;
      return true;
    }
  }
  emailTest() {
    const regEmail = RegService.EMAIL;
    const that = this;
    if (that.email.val != "" && !regEmail.test(that.email.val)) {
      that.$message.error("邮箱格式不正确");
      that.email.val = "";
    } else {
      that.email.err = false;
    }
  }
  subCase() {
    if (!this.isCheck) {
      this.$message.error("请仔细阅读并同意隐私协议");
      return;
    }
    if (this.pname == "") {
      this.$message.error("请输入合作项目名称");
    } else if (this.pdata == "") {
      this.$message.error("请输入申请日期");
    } else if (this.puser == "") {
      this.$message.error("请输入联系人");
    } else if (this.phone.val == "") {
      this.$message.error("请输入联系电话");
    } else if (this.email.val == "") {
      this.$message.error("请输入邮箱");
    } else if (this.casename == "") {
      this.$message.error("请输入课程(案例)标题");
    } else if (this.casecon1 == "") {
      this.$message.error("请输入课程(案例)内容");
    } else if (this.casename2 == "") {
      this.$message.error("请输入实验课程(案例)标题");
    } else if (this.casecon2 == "") {
      this.$message.error("请输入实验课程(案例)内容-实验简介");
    } else if (this.casecon3 == "") {
      this.$message.error("请输入实验课程(案例)内容-实验环境介绍");
    } else if (this.casecon4 == "") {
      this.$message.error("请输入实验课程(案例)内容-数据集介绍");
    } else if (this.casecon5 == "") {
      this.$message.error("请输入背景知识介绍");
    } else if (this.casename3 == "") {
      this.$message.error("请输入授课时长预估");
    } else if (this.checkList == "") {
      this.$message.error("请勾选合作形式");
    } else if (this.casename4 == "") {
      this.$message.error("请输入期望收益");
    } else if (this.casecon6 == "") {
      this.$message.error("请输入公司/个人 简介");
    } else if (this.rulecode==""){
      this.$message.error("请输入验证码");
    } else {
      const data = {
        projectName: this.pname,
        applicationDate: this.pdata,
        contact: this.puser,
        contactPhone: this.phone.val,
        email: this.email.val,
        cooperationMode: parseInt(this.radio),
        courseName: this.casename,
        courseDescription: this.casecon1,
        expCourseName: this.casename2,
        expIntro: this.casecon2,
        expEnvIntro: this.casecon3,
        expDataIntro: this.casecon4,
        expBgIntro: this.casecon5,
        expDuration: this.casename3,
        expectCooperationType: this.checkList,
        expectEarnings: this.casename4,
        intro: this.casecon6,
        code:this.rulecode,
        codeNum:this.rulecodes,
        signStatus:this.isCheck
      };
      // console.log(data);
      PartnerService.addCooperationCourse(data).then((res: any) => {
        if (res.data) {
          this.$message.success(res.message);
          this.pname = "";
          this.phone.val = "";
          this.email.val = "";
          this.radio = "3";
          this.casename = "";
          this.casecon1 = "";
          this.casename2 = "";
          this.casecon2 = "";
          this.casecon3 = "";
          this.casecon4 = "";
          this.casecon5 = "";
          this.casename3 = "";
          this.checkList = "";
          this.casename4 = "";
          this.casecon6 = "";
          this.rulecode="";
          this.getCode();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
}
